<template>
<div class="chapter">
<div class="inner_page">
<div class="blockquote" style="margin-top: 3em;">
<div class="blockquote1">
<p class="noindent"><em>After the Day of the Lie gather in select circles</em></p>
<p class="noindent"><em>Shaking with laughter when our real deeds are mentioned</em>.</p>
<p class="right1"><span>Czesław Miłosz, ‘Child of Europe’</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface003.vue?613ee3f5